import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AnnualReportProvider, FeatureState } from '../../../../../aumico-lib-annualreport-fe/src/public-api';
import { ProjectsOverviewActions } from '../../../../../aumico-lib-projects-fe/src/lib';

@Component({
    selector: 'app-annualreport',
    template: `<router-outlet></router-outlet>`,
})
export class AnnualReportPage implements OnInit, OnDestroy {
    constructor(
        private activatedRoute: ActivatedRoute,
        private store: Store<FeatureState>,
        private annualReportProvider: AnnualReportProvider,
    ) {
        // This component serves as a container for the annual report microservice.
        // It allows for lazy loading of the annual report module.
    }

    ngOnDestroy(): void {
        this.annualReportProvider.resetActiveAnnualReport(); // Reset the active annual report
    }

    ngOnInit(): void {
        // Initialization logic can be added here if needed.
        // For now, it simply serves as a placeholder for the router outlet.
        this.loadDataBasedOnProjectId();
    }

    private loadDataBasedOnProjectId(): void {
        const projectId = this.findProjectIdInRoute(this.activatedRoute);
        const queryParams = this.activatedRoute.snapshot.queryParams;

        if (projectId) {
            this.store.dispatch(
                ProjectsOverviewActions.fetchProjectDataByProjectId({
                    projectId: projectId,
                }),
            );
        } else {
            console.warn('No projectId found in route params.');
        }
    }

    private findProjectIdInRoute(route: ActivatedRoute): string | null {
        let currentRoute: ActivatedRoute | null = route;
        while (currentRoute) {
            const snapshot = currentRoute.snapshot;
            if (snapshot.paramMap.has('id')) {
                return snapshot.paramMap.get('id');
            }
            currentRoute = currentRoute.firstChild;
        }
        return null;
    }
}
